import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=lush%20green%20nature%20botanical%20herbs%20plants%20background%20with%20soft%20light%20rays%20through%20leaves%2C%20fresh%20healthy%20organic%20feel%2C%20blurred%20background%20with%20vibrant%20green%20tones%2C%20minimalist%20clean%20aesthetic%20for%20biotech%20health%20supplement%20brand&width=1920&height=1080&seq=hero-kangyong-01&orientation=landscape"
          alt="康永生技 首頁背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/30 to-black/10" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 py-28 pb-20 lg:py-0">
        <div className="max-w-2xl">
          <span className="inline-block bg-[#4CAF50]/20 border border-[#4CAF50]/50 text-[#7ed87f] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-6 tracking-wide">
            專業 ODM / OEM 代工服務
          </span>
          <h1 className="text-white font-bold leading-tight mb-6">
            <span className="block text-[2rem] md:text-[2.75rem] leading-[1.25]">
              康永生技
            </span>
            <span className="block text-[2rem] md:text-[2.75rem] leading-[1.25]">
              專業代工服務
            </span>
            <span className="block text-[1.25rem] md:text-[1.625rem] font-medium text-green-300 mt-2">
              最值得信賴的代工夥伴
            </span>
          </h1>
          <p className="text-gray-200 text-[1.125rem] leading-[1.75] mb-10 max-w-xl">
            從配方研發、生產製造到包裝出貨，提供保健食品與生技產品一站式 ODM／OEM 代工服務，助您快速上市。
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-4">
            <Link
              to="/contact/form"
              className="whitespace-nowrap bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1.0625rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              立即諮詢
            </Link>
            <Link
              to="/services"
              className="whitespace-nowrap bg-white/15 hover:bg-white/25 border border-white/60 text-white font-semibold text-[1.0625rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              了解服務
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10 animate-bounce">
        <span className="text-white/50 text-[0.8125rem] tracking-widest">SCROLL</span>
        <i className="ri-arrow-down-line text-white/50 text-xl" />
      </div>
    </section>
  );
}
